module.exports = __webpack_public_path__ + "static/gallery_15-10526dbce49679221d50e688f26a6115.jpg";